
























import Table from '@/components/tables/Table.vue'
import { ITableConfig } from '@/interfaces'
import { PaymentsModule } from '@/store/modules/payments.module'
import { IPayment, IPreferredPayersForPayment, isNonEmptyArray } from '@zunta/configurations'
import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
@Component({
  components: {
    Table
  },
  props: {
    paymentId: {
      type: Number,
      required: true,
    },
    xPos: {
      type: Number,
      required: true,
    }
  }
})
export default class PreferredPayersForPayment extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  preferredPayersForPayment: IPreferredPayersForPayment[] = []

  config: ITableConfig = {
    fetchFunction: this.getPreferredPayersForPayment,
    columns: [
      {
        minWidth: '200px',
        width: 60,
        key: 'payerType',
        label: 'Payer'
      },
      {
        minWidth: '160px',
        width: 25,
        key: 'effectiveDate',
        label: 'Effective Date'
      },
      {
        minWidth: '105px',
        width: 20,
        key: 'amount',
        label: 'Amount'
      }
    ]
  }

  get payment () {
    return this.$props.paymentProp as IPayment
  }

  async getPreferredPayersForPayment () {
    const res = await this.paymentsModuleInstance.getPreferredPayersForPayment(this.$props.paymentId)
    if (isNonEmptyArray(res)) {
      this.preferredPayersForPayment = res
    } else {
      this.preferredPayersForPayment = [{
        payer: 'Private Pay',
      }]
    }
    this.preferredPayersForPayment.push({
      payer: 'Default',
    })
  }
}
